import { lazy } from "react";

export const VisitsCalendarAsync = lazy(() => import("./VisitsCalendar"));
